const flag = "production";

const env = {
  production: {
    BACKEND_URL: "https://api.valuesalespresentationbuilder.com/",
    BACKEND_STORAGE_URL: "https://api.valuesalespresentationbuilder.com/storage",
    API_URL: "https://api.valuesalespresentationbuilder.com/api",
    FRONTEND_URL: "https://valuesalespresentationbuilder.com/",
  },
  staging: {
    BACKEND_URL: "http://127.0.0.1:8000",
    BACKEND_STORAGE_URL: "http://127.0.0.1:8000/storage",
    API_URL: "http://127.0.0.1:8000/api",
    FRONTEND_URL: "https://qm-frontend.vercel.app",
  },
};

export default {
  ...env[flag],
  flag: flag,
};
